<template>
    <div class="wrapper">
        <div v-if="notice" class="notice-detail padding-sm margin-bottom-sm">
            <div class="flex align-start justify-between margin-bottom-sm">
                <h3 class="notice-title">{{ notice.title }}<span>({{ notice.state | status }})</span></h3>

                <el-button class="blue-btn" round type="primary" @click="$router.go(-1)"
                >返回
                </el-button
                >

            </div>
            <div v-if="notice.state === 2" class="notice-reason">
                拒绝原因：{{ notice.state_msg }}
            </div>
            <div class="notice-num margin-bottom-sm">
                <span class="margin-right-xs">已读：<i>{{ notice.read_num }}人</i> </span>
                <span class="margin-right-xs">未读：<i class="active">{{ notice.not_read_num }}人</i> </span>
                <span v-if="notice.is_feedback === 1"
                      class="margin-right-xs">已反馈：<i>{{ notice.feedback_num }}人</i> </span>
                <span v-if="notice.is_feedback === 1" class="margin-right-xs">未反馈：<i
                    class="active">{{ notice.not_feedback_num }}人</i></span>
            </div>

            <div class="notice-info" v-html="notice.content"></div>

            <div v-if="notice.file_json.length>0" class="margin-tb-sm">
                <h3 class="margin-bottom-xs">附件</h3>
                <div v-for="(items,index) in notice.file_json" :key="index" class="flex align-center margin-bottom-xs">
                    <el-link :href="items.url" class="margin-right" target="_blank">{{ items.name }}</el-link>
                    <el-button type="text" @click="downloadFile(items.url,items.name)">下载</el-button>
                </div>
            </div>

            <div v-if="user.isBranch" class="flex justify-end">
                <router-link :to="'/branch/notice/edit/' + noticeId">
                    <el-button class="goback" round type="primary">编辑</el-button>
                </router-link>

                <el-button
                    class="line-btn margin-left-xs"
                    round
                    @click="delItem"
                >删除
                </el-button
                >
            </div>
        </div>

        <div v-if="notice " class="feedback-box padding-sm flex-sub">
            <div class="flex align-start justify-between margin-bottom-sm">
                <h3 class="feedback-title">
                    {{ notice.is_feedback === 1 ? '公告反馈' : '阅读状态' }}
                </h3>

                <el-link
                    :href="baseURL + 'Admin/notice/exportFeedBack?id=' + noticeId + '&mid='+user.mid + '&sign=' + user.sign">
                    <el-button v-if="notice.is_feedback === 1" class="feedback-export" round
                               type="primary">
                        反馈信息导出
                    </el-button>
                </el-link>


            </div>
            <div class="notice-num margin-bottom-sm">
                <span class="margin-right-xs">已读：<i>{{ notice.read_num }}人</i> </span>
                <span class="margin-right-xs">未读：<i class="active">{{ notice.not_read_num }}人</i> </span>
                <span v-if="notice.is_feedback === 1" class="margin-right-xs">已反馈：<i>{{
                        notice.feedback_num
                    }}人</i> </span>
                <span v-if="notice.is_feedback === 1" class="margin-right-xs">未反馈：<i class="active">{{
                        notice.not_feedback_num
                    }}人</i>
        </span>
            </div>
            <div
                class=" flex align-center justify-between margin-bottom-sm feedback-search"
            >
                <el-select
                    v-if="notice.is_feedback === 1"
                    v-model="feedbackState"
                    class="margin-right-xs"
                    placeholder="请选择反馈状态"
                >
                    <el-option
                        v-for="item in feedbackStateList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value"
                    >
                    </el-option>
                </el-select>
                <el-input v-model="keyWord" placeholder="请输入机构名称"></el-input>
                <el-button icon="el-icon-search" type="primary" @click="getNoticeFeedback">搜索</el-button>
            </div>
            <div class="ship-list">
                <el-table
                    v-loading="loading"
                    :data="feedbackList"
                    border
                    header-row-class-name="table-header"
                    style="width: 100%; border-radius: 10px"
                >
                    <el-table-column label="序号" type="" width="80">
                        <template slot-scope="scope">
                            <div class="flex justify-center">{{ scope.$index + 1 }}</div>
                        </template>
                    </el-table-column>
                    <el-table-column label="机构名称" prop="company">
                        <template slot-scope="scope">
                            <div class="flex justify-center">{{ scope.row.company }}</div>
                        </template>
                    </el-table-column>
                    <el-table-column label="阅读状态" prop="legal_person_name">
                        <template slot-scope="scope">
                            <div class="flex justify-center"> {{ scope.row.is_read === 0 ? '未读' : '已读' }}</div>
                        </template>
                    </el-table-column>
                    <el-table-column v-if="notice.is_feedback === 1" label="反馈状态" prop="tel_name">
                        <template slot-scope="scope">
                            <div class="flex justify-center"> {{ scope.row.is_feedback === 0 ? '未反馈' : '已反馈' }}</div>
                        </template>
                    </el-table-column>
                    <el-table-column v-if="notice.is_feedback === 1" label="反馈时间" prop="tel_number">
                        <template slot-scope="scope">
                            <div class="flex justify-center">
                                {{ scope.row.feedback_time |time }}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column v-if="notice.is_feedback === 1" label="查看反馈">
                        <template slot-scope="scope">
                            <div class="flex justify-center">
                                <el-button v-if="scope.row.feedback" class="blue-btn"
                                           @click="showFeed(scope.row.feedback)">查看反馈
                                </el-button>
                                <span v-else>--</span>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </div>
        <notice-feedback-show-dialog
            :applyDialogVisible="applyDialogVisible"
            :json="feedback"
            @feedbackState="closeDialog"/>
    </div>
</template>

<script>
import NoticeFeedbackShowDialog from "@/components/NoticeFeedbackShowDialog";
import {getNoticeFeedback, noticeDel, noticeDetail} from '@/api/branch'
import {zhDate} from '@/utils/utils'
import {baseURL} from "@/config";
import {downloadFile} from "@/api/login";

export default {
    name: "detail",
    components: {NoticeFeedbackShowDialog},
    data() {
        return {
            keyWord: '',
            notice: null,
            feedbackList: [],
            feedbackState: '',
            feedbackStateList: [
                {label: '全部', value: 0},
                {label: '已反馈', value: 1},
                {label: '未反馈', value: 2}
            ],
            tableData: [],
            loading: false,
            baseURL: baseURL,
            feedback: '',
            applyDialogVisible: false
        }
    },
    created() {
        this.$emit('setIndex', [1, 0], '通知公告')
        this.getDetail()
    },
    computed: {
        noticeId() {
            return this.$route.params.id
        },
        user() {
            return this.$store.state.user
        }
    },
    methods: {
        //  显示反馈
        showFeed(str) {
            this.applyDialogVisible = true
            this.feedback = str
        },
        closeDialog() {
            this.applyDialogVisible = false
            this.feedback = ''
        },
        //    删除通知公告
        delItem() {
            this.$confirm(this.notice.feedback_num ? `此通知有${this.notice.feedback_num}条反馈信息，是否确定删除？` : `此操作将删除该通知公告, 是否继续?`, '温馨提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.sureDelete(this.noticeId)
            })
        },
        async sureDelete(id) {
            let _state = await noticeDel(id)
            if (_state.status === 200) this.$message.success(_state.msg), this.$router.go(-1)
        },
        async getDetail() {
            let _data = await noticeDetail(this.noticeId)
            this.notice = _data.data
            this.notice.file_json = JSON.parse(this.notice.file_json)
            await this.getNoticeFeedback()
        },
        async getNoticeFeedback() {
            let _list = await getNoticeFeedback(this.feedbackState, this.keyWord, this.noticeId)
            this.feedbackList = _list.data
        },
        async downloadFile(fileUrl, fileName) {
            if (!fileUrl) {
                return;
            }
            let _data = await downloadFile(fileUrl)
            let url = window.URL.createObjectURL(new Blob([_data.data]));
            let link = document.createElement('a');
            link.style.display = 'none';
            link.href = url;
            link.setAttribute('download', fileName);
            document.body.appendChild(link);
            link.click();
        }
    },
    filters: {
        time(val) {
            return val ? zhDate(val * 1000) : '--'
        },
        status(type) {
            switch (Number(type)) {
                case 1:
                    return "待审核";
                case 2:
                    return "审核驳回";
                default:
                    return "审核通过";
            }
        }
    }

}
</script>

<style lang="scss" scoped>
.wrapper {
    .notice-detail {
        background: #fff;
        border-radius: 10px;

        .notice-title {
            width: 80%;
            font-size: 26px;
            line-height: 40px;
            color: #333333;
        }

        .goback {
            background: #0a2240;
            border: 1px solid #0a2240;
            width: 100px;
        }

        .notice-num {
            i {
                color: #ffb400;

                &.active {
                    color: #fc4902;
                }
            }
        }
    }

    .notice-reason {
        border: 1px dashed #fc4902;
        padding: 10px;
        margin-bottom: 10px;
    }

    .feedback-box {
        background: #fff;
        border-radius: 10px;

        .feedback-title {
            line-height: 40px;
            font-size: 26px;
        }

        .feedback-export {
            width: 200px;
            background-image: linear-gradient(37deg, #ffb400 0%, #fc7802 100%),
            linear-gradient(#0a2240, #0a2240);
            background-blend-mode: normal, normal;
        }

        .notice-num {
            i {
                color: #ffb400;

                &.active {
                    color: #fc4902;
                }
            }
        }

        .feedback-search {
            .el-input__inner {
                border-top-right-radius: 0;
                border-bottom-right-radius: 0;
            }

            .el-button {
                border-top-left-radius: 0;
                border-bottom-left-radius: 0;
                background: #0a2240;
                border: 0;
                font-size: 16px;
            }
        }
    }
}
</style>